module.exports = __webpack_public_path__ + "static/media/oliverEllsworth.2cddbfda.png";